import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import { Link as RouterLink } from 'react-router-dom';
import shareFill from '@iconify/icons-eva/share-fill';
import messageCircleFill from '@iconify/icons-eva/message-circle-fill';
// material
import { alpha, styled } from '@mui/material/styles';
import { Box, Link, Card, Grid, Avatar, Typography, CardContent } from '@mui/material';
// utils
import { fDate } from '../../../utils/formatTime';
import { fShortenNumber } from '../../../utils/formatNumber';
//
import SvgIconStyle from '../../../components/SvgIconStyle';
import { mockImgCover } from '../../../utils/mockImages';

// ----------------------------------------------------------------------

const CardMediaStyle = styled('div')({
  position: 'relative',
  paddingTop: 'calc(100% * 3 / 4)'
});

const TitleStyle = styled(Link)({
  height: 44,
  overflow: 'hidden',
  WebkitLineClamp: 2,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical'
});

const AvatarStyle = styled(Avatar)(({ theme }) => ({
  zIndex: 9,
  width: 32,
  height: 32,
  position: 'absolute',
  left: theme.spacing(3),
  bottom: theme.spacing(-2)
}));

const InfoStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(3),
  color: theme.palette.text.disabled
}));

const CoverImgStyle = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  // objectFit: 'cover',
  position: 'absolute'
});
// const CenteredLogo = styled(Box)(({ theme }) => ({
//   display: "flex",
//   // justifyContent: "center",
//   // alignItems: "center",
//   // marginBottom: theme.spacing(3),
// }));
const CenteredLogo = styled(Box)(({ theme }) => ({
  position: 'absolute',  // Position absolutely within the parent container
  bottom: theme.spacing(2),  // Place it at the bottom with spacing
  left: theme.spacing(2),  // Align it to the left with spacing
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 10,  // Ensure the logo is above other elements

  // Add responsive adjustments for mobile view
  [theme.breakpoints.down('sm')]: {
    bottom: theme.spacing(1),
    left: theme.spacing(1),
    '& img': {
      width: '80px',  // Scale the logo size for mobile
      height: '70px',
    },
  }
}));

// ----------------------------------------------------------------------

BlogPostCard.propTypes = {
  post: PropTypes.object.isRequired,
  index: PropTypes.number
};

export default function BlogPostCard({ post, index }) {
  // const { cover, title, view, comment, share, author, createdAt } = post;'
  const cover = mockImgCover(index + 1)
  const latestPostLarge = index === 0;
  const latestPost = index === 1 || index === 2;

  const POST_INFO = [
    { number: 1, icon: messageCircleFill },
    { number: 1, icon: eyeFill },
    { number: 1, icon: shareFill }
  ];

  return (
    <Grid item xs={12} sm={latestPostLarge ? 12 : 6} md={latestPostLarge ? 6 : 3}>
      <Card sx={{ position: 'relative' }}>
        <CardMediaStyle
          sx={{
            // ...((latestPostLarge || latestPost) && {
            //   pt: 'calc(100% * 4 / 3)',
            //   '&:after': {
            //     top: 0,
            //     content: "''",
            //     width: '100%',
            //     height: '100%',
            //     position: 'absolute',
            //     bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
            //   }
            // }),
            // ...(latestPostLarge && {
              pt: {
                xs: 'calc(100% * 1/2)',
                sm: 'calc(100% * 1/2.5)'
              }
            // })
          }}
        >
          {/* <SvgIconStyle
            color="paper"
            src="/static/icons/shape-avatar.svg"
            sx={{
              width: 80,
              height: 36,
              zIndex: 9,
              bottom: -15,
              position: 'absolute',
              ...((latestPostLarge || latestPost) && { display: 'none' })
            }}
          />
          <AvatarStyle
            // alt={author.name}
            // src={author.avatarUrl}
            sx={{
              ...((latestPostLarge || latestPost) && {
                zIndex: 9,
                top: 24,
                left: 24,
                width: 40,
                height: 40
              })
            }}
          /> */}

          <CoverImgStyle 
            // alt={title}
            src={cover} 
           />
        </CardMediaStyle>

        <CardContent
          sx={{
            pt: 4,
            ...((latestPostLarge || latestPost) && {
              bottom: 0,
              width: '100%',
              position: 'absolute'
            })
          }}
        >
          <Typography
            gutterBottom
            variant="caption"
            sx={{ color: 'text.disabled', display: 'block' }}
          >
            {/* {fDate(createdAt)} */}
          </Typography>

          <TitleStyle
            to="#"
            color="black"
            variant="subtitle2"
            underline="hover"
            component={RouterLink}
            sx={{
              typography: 'h5', height: 200,
              
                color: 'common.black'
              
            }}
          >
          <CenteredLogo>
              <Box
                component="img"
                src="/static/logormbg.png"
                sx={{ width: 147/1.5, height: 130/1.5 }}
              />
            Hospital Of the Holy Cross

          </CenteredLogo>
            {/* {title} */}
          </TitleStyle>

          {/* <InfoStyle>
            {POST_INFO.map((info, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  ml: index === 0 ? 0 : 1.5,
                  ...((latestPostLarge || latestPost) && {
                    color: 'grey.500'
                  })
                }}
              >
                <Box component={Icon} icon={info.icon} sx={{ width: 16, height: 16, mr: 0.5 }} />
                <Typography variant="caption">{fShortenNumber(info.number)}</Typography>
              </Box>
            ))}
          </InfoStyle> */}
        </CardContent>
      </Card>
    </Grid>
  );
}
